<template>
  <vs-alert type="info" class="mb-2">
    {{ message }}
  </vs-alert>
</template>

<script setup lang="ts">
import { formatDuration } from '@/utils/date-formatting'
import { usePoolExclusivityStatusQuery } from '@/api/pools'
import { ref, watchEffect, toRef, onUnmounted } from 'vue'
import moment from 'moment'

const interval = ref()
const message = ref()

const props = defineProps<{ poolId: string }>()
const poolIdRef = toRef(props, 'poolId')

const { data } = usePoolExclusivityStatusQuery(poolIdRef)

watchEffect(() => {
  if (!data.value) {
    return
  }

  if (!data.value.hasExclusivity) {
    message.value = 'You and other service providers have access to claim this job'
    return
  }

  if (data.value.exclusiveUntil === null) {
    message.value = 'You have exclusive access to claim this job'
    return
  }

  if (interval.value) {
    clearInterval(interval.value)
  }

  // Placeholder value until the interval runs
  message.value = 'You have exclusive access to claim this job for...'

  const dueBy = moment.utc(data.value.exclusiveUntil)
  interval.value = setInterval(() => {
    const duration = moment.duration(dueBy.diff(moment.utc()))

    if (duration.asMilliseconds() <= 0) {
      clearInterval(interval.value)
      message.value = 'You and other service providers have access to claim this job'
      return
    }

    const timeRemaining = formatDuration(duration)
    message.value = `You have exclusive access to claim this job for ${timeRemaining}`
  }, 1000)
})

onUnmounted(() => {
  clearInterval(interval.value)
})
</script>

<style scoped></style>
